import "./Industries.css";

import {
    FaUtensils,
    FaFlask,
    FaPills,
    FaSeedling,
    FaIndustry,
    FaWarehouse,
    FaTruck,
    FaBuilding
} from "react-icons/fa";

function Industries(){

const industries=[

{
icon:<FaUtensils/>,
title:"Food Processing"
},

{
icon:<FaPills/>,
title:"Pharmaceutical"
},

{
icon:<FaFlask/>,
title:"Chemical"
},

{
icon:<FaSeedling/>,
title:"Agriculture"
},

{
icon:<FaBuilding/>,
title:"FMCG"
},

{
icon:<FaIndustry/>,
title:"Manufacturing"
},

{
icon:<FaWarehouse/>,
title:"Construction"
},

{
icon:<FaTruck/>,
title:"Logistics"
}

];

return(

<section className="industries" id="industries">

<div className="container-custom">

<div className="section-heading">

<span>

INDUSTRIES WE SERVE

</span>

<h2>

Packaging Solutions
For Every Industry

</h2>

<p>

Delivering innovative packaging solutions that
meet the highest standards of quality,
performance and reliability across multiple
industries.

</p>

</div>

<div className="row g-4">

{

industries.map((item,index)=>(

<div
className="col-lg-3 col-md-6"
key={index}
>

<div className="industry-card">

<div className="industry-icon">

{item.icon}

</div>

<h4>

{item.title}

</h4>

</div>

</div>

))

}

</div>

<div className="industry-metrics">

<div>

<h3>30+</h3>

<p>Years Experience</p>

</div>

<div>

<h3>8+</h3>

<p>Products</p>

</div>

<div>

<h3>Pan India</h3>

<p>Distribution</p>

</div>

<div>

<h3>Eco</h3>

<p>Sustainable Solutions</p>

</div>

</div>

</div>

</section>

);

}

export default Industries;